export default __webpack_public_path__ + "static/media/Flaticon.84e38925.eot";